/**
 * 商品枚举 → 中文标签(对齐 App PublishPage UNIT/MEDIUM_OPTIONS 与 SellerProductRow UNIT_LABEL)。
 * 计价单位 TIMES/SESSIONS/HOURS = 次/局/小时(code-authoritative);介质 IM/VOICE/VIDEO/OFFLINE。
 * iter-010 实物扩类(30-2):计价 += PIECE(件);介质 += EXPRESS(快递)/PICKUP(自提)。
 */
import type { ProductMedium, ProductStatus, ProductUnit } from '@/api/products';

export const UNIT_OPTIONS: { value: ProductUnit; label: string }[] = [
  { value: 'TIMES', label: '次' },
  { value: 'SESSIONS', label: '局' },
  { value: 'HOURS', label: '小时' },
  { value: 'PIECE', label: '件' },
];

export const MEDIUM_OPTIONS: { value: ProductMedium; label: string }[] = [
  { value: 'IM', label: '站内 IM' },
  { value: 'VOICE', label: '语音' },
  { value: 'VIDEO', label: '视频' },
  { value: 'OFFLINE', label: '线下' },
  { value: 'EXPRESS', label: '快递' },
  { value: 'PICKUP', label: '自提' },
];

export const UNIT_LABEL: Record<string, string> = Object.fromEntries(
  UNIT_OPTIONS.map((o) => [o.value, o.label]),
);

/** 介质枚举名 → 中文(展示层用;实物配送方式 EXPRESS/PICKUP 亦经此映射)。 */
export const MEDIUM_LABEL: Record<string, string> = Object.fromEntries(
  MEDIUM_OPTIONS.map((o) => [o.value, o.label]),
);

/** W-8 分组顺序与组头文案(pages/seller-products.md)。 */
export const STATUS_ORDER: ProductStatus[] = ['PENDING_AUDIT', 'ONLINE', 'OFFLINE', 'REJECTED'];

export const STATUS_LABEL: Record<ProductStatus, string> = {
  DRAFT: '草稿',
  PENDING_AUDIT: '审核中',
  ONLINE: '在售',
  OFFLINE: '已下架',
  REJECTED: '审核驳回',
};

/** 分 → 「¥N」(整数元,已知后端存整数分且提交为整数元)。 */
export function formatPriceYuan(fen: number): string {
  return `¥${Math.round(fen / 100)}`;
}
